<div class="row mt-4">
  <div class="col-md-12">
    <mat-card class="property-card">
      <!-- Title & Subtitle on the Left -->
      <div class="mat-card-group">
        <mat-card-title class="card-heading">More Details</mat-card-title>
      </div>

      <mat-card-content>
        <div class="row">
          <div class="col-md-12" *ngIf="cmaViewDetails?.reportCategory != 'smartReport'">
            <h4 class="mb-3 headWrap">Letter to Customer</h4>
            <div style="line-height: 1.5">
              Dear <b>{{ cmaViewDetails?.clientName }}</b
              ><br /><br />I am happy to present the {{ reportType }}
              {{ reportType == 'CMA' ? '(Comparative Market Analysis) report' : '' }} for the property at
              <b>{{ cmaViewDetails?.reportName }} </b>We have done an extensive analysis using recent closed
              transactions and active listings of similar properties in the neighborhood to arrive at the fair market
              value of your property.<br /><br />This helps to determine a suitable listing price for your property. The
              fair market value of a home is determined by the price at which a buyer and seller would agree within a
              reasonable period of time, usually 90 days. While the fair market value is only an estimation, it is
              important to take into account the condition of the home, property location, neighborhood amenities etc.
              and make adjustments to reflect the market scenario.<br /><br />This {{ reportType }}
              {{ reportType == 'CMA' ? 'report' : '' }} includes information on current active listings and other
              recently sold properties in your neighborhood. These are the properties that an appraiser would use to
              determine the fair market value of your property. The report also uses the number of beds, baths, gross
              living area, price per square feet and Days on Market.<br /><br />Yours sincerely,<br /><b
                >iCMA Developer</b
              >
            </div>
            <h4 class="my-3 headWrap">What is {{ reportType }} ?</h4>
            <div class="row">
              <div class="col-md-4">
                <img class="img-fluid" src="~/../../assets/images/more/cma.jpg" />
              </div>
              <div class="col-md-8">
                {{ reportType }} stands for Comparative Market Analysis. {{ reportType }} is used to arrive at the fair
                market value of a home, which plays a key role to arrive at a suitable listing price for the
                property.<br /><br />

                {{ reportType }} takes into account recent property transactions and active listings in the neighborhood
                for similar properties.Similar properties are identified through a sophisticated algorithm that uses key
                property attributes.<br /><br />

                {{ reportType }} compares similar properties in the neighborhood in terms of number of bed, baths, lot
                size, living area, amenities within the property and a host of other property attributes.<br /><br />

                This process helps to arrive at the Fair Market Value for the property under consideration based on past
                sales, pending sales and homes that are currently listed for sale.{{ reportType }} presents the current
                market conditions and a lot depends on the local knowledge and expertise of the agent who is preparing
                the {{ reportType }}.
              </div>
            </div>

            <h4 class="my-3 headWrap">Marketing Action Plan</h4>
            <div class="row">
              <div class="col-md-8">
                We will provide the following services for your property.<br /><br />

                <div class="mb-2"><b>First Week on the Market</b></div>

                <ul class="mb-3">
                  <li>Enter details of your property in the MLS.</li>
                  <li>Take photos of the property.</li>
                  <li>Install signage on the lot.</li>
                  <li>Include your property in local marketing flyers and brochures.</li>
                  <li>List your property in relevant websites and portals for better coverage.</li>
                  <li>Ensure that your property is ready for showings by working through the checklist.</li>
                </ul>

                <div class="mb-2"><b>Second Week on the Market</b></div>

                <ul class="mb-3">
                  <li>Invite agents who operate in the neighborhood to visit your home.</li>
                  <li>Place ads with relevant print and online channels.</li>
                </ul>

                <div class="mb-2"><b>Third Week on the Market</b></div>

                <ul class="mb-3">
                  <li>Plan for Open House.</li>
                  <li>Give wide coverage to the Open House flyer prepared for your property.</li>
                  <li>Hold the Open House to attract the maximum number of prospective buyers.</li>
                </ul>

                <div class="mb-2"><b>On-going</b></div>

                <ul>
                  <li>Handle incoming calls and schedule showing appointments.</li>
                  <li>Update you on the interest expressed by the market.</li>
                  <li>Pre-qualify buyers.</li>
                  <li>Present all offers and recommend counter-offer strategies.</li>
                  <li>Review price based on market conditions.</li>
                  <li>Strive to close the transaction at the earliest within the price expectation you have.</li>
                </ul>
              </div>
              <div class="col-md-4">
                <img class="img-fluid" src="~/../../assets/images/more/action-plan.png" />
              </div>
            </div>

            <h4 class="my-3 headWrap">Showings and Open House Checklist</h4>
            <div class="row">
              <div class="col-md-4">
                <img class="img-fluid" src="~/../../assets/images/more/house-checklist.jpg" />
              </div>
              <div class="col-md-8">
                Once your home is listed, there will be a lot of interest among prospective buyers and their agents to
                view and learn more about your property. This is especially true if the property is priced closer to the
                fair market value of comparable properties.<br /><br />

                Add your checklist for showings and open house here<br /><br />

                Checklist for Keeping Your Home Ready
              </div>
            </div>

            <h4 class="my-3 headWrap">Preparing your Home</h4>
            <div class="row">
              <div class="col-md-8">
                The impression that a potential buyer has when they visit your property is a key factor that
                determineshow interested they would be in making an offer. It is important for the seller to create a
                clean andwelcoming atmosphere within the property that can swing the decision in your favor.Add your
                action items to enhance the value of your home under the following categories<br /><br />

                <div class="row w-100">
                  <div class="col-md-3">
                    <div class="mb-2"><b>Curb Appeal</b></div>
                    <ul>
                      <li>Lawn</li>
                      <li>Garden</li>
                      <li>Walkway</li>
                      <li>Weed</li>
                      <li>Driveway</li>
                      <li>Plants</li>
                      <li>Patio and deck area</li>
                      <li>Outdoor furniture</li>
                      <li>Pool or spa</li>
                      <li>Roof and gutters</li>
                      <li>Windows and shutters</li>
                      <li>Air conditioning units</li>
                      <li>Front door</li>
                      <li>Mailbox</li>
                    </ul>
                  </div>
                  <div class="col-md-3">
                    <div class="mb-2"><b>General Interior</b></div>
                    <ul>
                      <li>Lawn</li>
                      <li>Garden</li>
                      <li>Painting</li>
                      <li>Carpeting</li>
                      <li>Floors</li>
                      <li>Kitchen floor</li>
                      <li>Bathroom floor</li>
                      <li>Window sills</li>
                      <li>Fireplace</li>
                      <li>Closets</li>
                    </ul>
                  </div>
                  <div class="col-md-3">
                    <div class="mb-2"><b>The Living Room</b></div>
                    <ul>
                      <li>General Ambiance</li>
                      <li>Furniture</li>
                      <li>Windows</li>
                      <li>Rug or Carpets</li>
                    </ul>
                  </div>
                  <div class="col-md-3">
                    <div class="mb-2"><b>The Dining Room</b></div>
                    <ul>
                      <li>General Ambiance</li>
                      <li>Furniture</li>
                      <li>Windows</li>
                      <li>Lighting</li>
                      <li>Silverware and crystal</li>
                      <li>Set the table</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <img class="img-fluid" src="~/../../assets/images/more/prepare-home.png" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-2">
                <div class="mb-2"><b>The Kitchen</b></div>
                <ul>
                  <li>General ambience</li>
                  <li>Cleanliness of appliances</li>
                  <li>Working condition of appliances</li>
                  <li>Floor</li>
                  <li>Lighting</li>
                  <li>Cabinets</li>
                </ul>
              </div>
              <div lass="col-md-2">
                <div class="mb-2"><b>The Bathrooms</b></div>
                <ul>
                  <li>Tiles, fixtures</li>
                  <li>Shower doors</li>
                  <li>Floors</li>
                  <li>Lighting</li>
                </ul>
              </div>
              <div class="col-md-2">
                <div class="mb-2"><b>The Master Bedroom</b></div>
                <ul>
                  <li>Location of furniture</li>
                  <li>Furnishings</li>
                </ul>
              </div>
              <div class="col-md-2">
                <div class="mb-2"><b>The Garage </b></div>
                <ul>
                  <li>Lighting</li>
                  <li>Avoid clutter</li>
                  <li>Storage areas</li>
                </ul>
              </div>
              <div class="col-md-2">
                <div class="mb-2"><b>The Basement</b></div>
                <ul>
                  <li>Lighting</li>
                  <li>Storage areas</li>
                  <li>Condition of appliances installed</li>
                  <li>Furniture</li>
                </ul>
              </div>
            </div>

            <h4 class="my-3 headWrap">Importance of Intelligent Pricing and Timing</h4>
            <div class="row">
              <div class="col-md-4">
                <img class="img-fluid" src="~/../../assets/images/more/pricing.png" />
              </div>
              <div class="col-md-8">
                Identifying the optimum market price for your home is extremely important, and can be a real challenge.
                It is a well known fact that a fair price attracts lots of interest, whereas overpricing does not. If
                your home is listed above market value, the number of prospective buyers will be reduced. On the other
                hand, if your home is listed below market value, you are likely to close the transaction at a price
                below what it could have otherwise fetched. As shown in Figure 1, more number of purchases are done at
                market value or just below it. Therefore, by pricing your property appropriately you improve your
                chances of closing the transaction earlier and at a price that reflects the fair market value.<br /><br />
              </div>
            </div>
            <br /><br />
            <div class="row">
              <div class="col-md-8">
                The optimum time for listing is also a key factor in successfully selling your house. A property enjoys
                the most interest among different stakeholders for two weeks from the time it is first listed. As given
                in Figure 2, pricing the property improperly takes away the best chance of closing a transaction
                quickly. Once a property loses interest, it is likely to wait for a long period of time awaiting the
                right offer. If you are in a hurry to close the transaction, the property will fetch a price that is
                lower than market value. Therefore, having the right price at the time of first listing is critical.
              </div>
              <div class="col-md-4">
                <img class="img-fluid" src="~/../../assets/images/more/pricing2.png" />
              </div>
            </div>
            <br /><br />
            <div class="row">
              <div class="col-md-4">
                <img class="img-fluid" src="~/../../assets/images/more/pricing3.png" />
              </div>
              <div class="col-md-8">
                If you don't get many offers, it is probably a sign that you have overpriced your home and doesn't
                compare well with other properties in the market. The {{ reportType }}
                {{ reportType == 'CMA' ? '(Comparative Market Analysis) report' : '' }} provides a quick snapshot of the
                fair market value of a property by analyzing similar homes in the neighborhood that are currently listed
                as well as the ones that got closed recently. It is important to remember that the buyer is looking for
                the best value within a price range that fits their budget.
              </div>
            </div>

            <div
              *ngIf="
                (userRole == 'agent' && (portfolio?.licenseList?.length > 0 || portfolio?.experienceList?.length)) ||
                (userRole == 'loanOfficer' &&
                  (nvLicenseList?.length > 0 || createdBy?.nmlsNumber || createdBy?.branding))
              "
            >
              <h4 class="my-3 headWrap">
                {{ userRole === 'agent' ? "Agent's Profile" : "Loan Officer's Profile" }}
              </h4>

              <div class="row">
                <div class="col-md-4"></div>
                <div class="col-md-4">
                  <img class="img-fluid" src="~/../../assets/images/more/Agent-profile.png" />
                </div>
                <div class="col-md-4"></div>
                <br /><br />
              </div>

              <div *ngIf="userRole == 'agent'">
                <div class="mb-3" *ngIf="portfolio && portfolio?.licenseList && portfolio?.licenseList.length > 0">
                  <div class="row">
                    <div class="col-md-12">
                      <h5>Licensing</h5>
                    </div>
                  </div>
                  <div class="row" *ngFor="let license of portfolio.licenseList">
                    <div class="col-md-3">
                      <strong>Affiliation Name</strong><br />
                      {{ license.licensedAs || '-' }}
                    </div>
                    <div class="col-md-3">
                      <strong>Licensing Authority</strong><br />
                      {{ license.authority || '-' }}
                    </div>
                    <div class="col-md-3">
                      <strong>License Number</strong><br />
                      {{ license.number || '-' }}
                    </div>
                    <div class="col-md-3">
                      <strong>Initial Licensing Date</strong><br />
                      {{ license.yearIssued || '-' }}
                    </div>
                  </div>
                </div>

                <div class="mb-3" *ngIf="portfolio?.experienceList && portfolio.experienceList.length">
                  <div class="row">
                    <div class="col-md-12">
                      <h5>Experience</h5>
                    </div>
                  </div>
                  <div class="row" *ngFor="let experience of portfolio.experienceList">
                    <div class="col-md-3">
                      <strong>Company Name</strong><br />
                      {{ experience.companyName || '-' }}
                    </div>
                    <div class="col-md-3">
                      <strong>Title</strong><br />
                      {{ experience.title || '-' }}
                    </div>
                    <div class="col-md-3">
                      <strong>Location</strong><br />
                      {{ experience.location || '-' }}
                    </div>
                    <div class="col-md-3">
                      <strong>Experience in Years</strong><br />
                      {{ experience.experience || '-' }}
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="userRole == 'loanOfficer'">
                <div class="mb-3" *ngIf="nvLicenseList.length">
                  <div class="row">
                    <div class="col-md-12">
                      <h5>Licensing</h5>
                    </div>
                  </div>
                  <div class="row" *ngFor="let license of nvLicenseList">
                    <div class="col-md-3">
                      <strong>License State</strong><br />
                      {{ license.nvState || '-' }}
                    </div>
                    <div class="col-md-3">
                      <strong>License Number</strong><br />
                      {{ license.licenseNumber || '-' }}
                    </div>
                  </div>
                </div>

                <div class="row mb-3" *ngIf="createdBy?.branding">
                  <div class="col-md-3">
                    <strong>Company Name</strong><br />
                    {{ createdBy?.branding.name || '--' }}
                  </div>
                  <div class="col-md-3">
                    <strong>Email</strong><br />
                    {{ createdBy?.branding.email || '--' }}
                  </div>
                  <div class="col-md-3">
                    <strong>NMLS</strong><br />
                    {{ createdBy?.branding.nmls || '--' }}
                  </div>
                </div>
                <br /><br /><br />
                <div class="row" *ngIf="createdBy.nmlsNumber">
                  <div class="col-md-3">
                    <strong>NMLS Number</strong><br />
                    {{ createdBy.nmlsNumber || '--' }}
                  </div>
                </div>
              </div>
            </div>

            <h4 class="my-3 headWrap">Features That Sell</h4>
            <div class="row">
              <div class="col-md-8">
                Location and attributes of the residential property are the key factors in determining the fair market
                value. There are other factors that enhance or reduce the value of a property. These are listed
                below:<br /><br />

                Location - A better location fetches a higher value for the property. The closer a home is to offices,
                transit points, schools, community service centers, and lifestyle amenities, the higher will be the
                premium when compared to another similar property that is located further away.<br /><br />

                Size - The higher the square footage of the house, the bigger the house. A bigger lot size implies a
                larger land area which can be used for future modifications to the property.<br /><br />

                Number of bedrooms and baths - As the number of household amenities that are in good condition
                increases, the value of the property increases.<br /><br />

                Features and finishes - An outdoor kitchen or a spa gives a better feel of the property. The work done
                on finishing the kitchen, bedroom, bathroom and living area adds value to the property in the eyes of
                the buyer.<br /><br />

                Condition - Homes that look similar to a new construction with state of the art facilities fetch a
                higher value. Homes in bad condition with a neglected look for the interior and exterior features
                degrades the value of the property.<br /><br />

                Condition - Homes that look similar to a new construction with state of the art facilities fetch a
                higher value. Homes in bad condition with a neglected look for the interior and exterior features
                degrades the value of the property.<br /><br />

                Curb appeal - It is important for a prospective buyer to get a good fee about the house right from the
                street.<br /><br />

                Walkways/driveways - All walkways should be clean and maintained well.<br /><br />

                Landscaping - The lawn should be mowed and watered. Dead plants and weeds should be removed.<br /><br />

                Exterior - Make sure that the door is freshly painted and any broken windows are repaired. Roof and
                gutters should be cleaned as well. When two houses are similar in the same neighborhood, the difference
                in value comes down to soft factors that the buyers feel about the property.<br /><br />
              </div>
              <div class="col-md-4">
                <img class="img-fluid" src="~/../../assets/images/more/prepare-home.png" />
              </div>
            </div>
            <h4 class="my-3 headWrap">Our Services</h4>
            <div class="row">
              <div class="col-md-4">
                <img class="img-fluid" src="~/../../assets/images/more/our-service.jpg" />
              </div>
              <div class="col-md-8">
                <ul>
                  <li>We will help you arrive at the optimum selling price for your home</li>
                  <li>We will advise you on the best approaches to increase the market value of your home.</li>
                  <li>We will create a plan to showcase your home to prospective buyers and their agents.</li>
                  <li>We will market your home according to the best practices in the industry.</li>
                  <li>We will review the progress with you periodically.</li>
                  <li>We will help you understand the market scenario and the latest trends we are seeing.</li>
                  <li>We will help you evaluate offers that are made on your home.</li>
                  <li>We will help you sign the contract and all steps involved in taking it closure.</li>
                  <li>We will help you settle the transaction in most convenient way.</li>
                </ul>
                <br /><br />
              </div>
            </div>
            <h4 class="my-3 headWrap">What to expect from your Agent?</h4>

            <div class="row">
              <div class="col-md-8">
                WHY YOU NEED A REAL ESTATE PROFESSIONAL?
                <br /><br />
                While it sounds attractive to sell the property yourself and save on the commission that you would have
                to pay a real estate agent, it is important not to ignore the following factors before you make your
                mind.The fair market value of a home is determined by the price at which a buyer and seller would agree
                within a reasonable period of time, usually 90 days. While the fair market value is only an estimation,
                it is important to take into account the condition of the home, property location, neighborhood
                amenities etc and make adjustments to reflect the market scenario.
                <br /><br />
                According to Realtor.org, real estate agents market houses better than owners, sell them faster and for
                more money. A real estate agent would be able to cover a wider network to market your property and use
                their professional training and experience in preparing your home for the sale and negotiating a better
                deal for you.
              </div>
              <div class="col-md-4">
                <img class="img-fluid" src="~/../../assets/images/more/profile.png" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                Real estate professionals provide several advantages

                <div class="mt-3">
                  <ul>
                    <li>They are licensed by professional associations.</li>
                    <li>They have several years of professional experience in the real estate market.</li>
                    <li>They have local market knowledge and know the neighborhood better.</li>
                    <li>They are bound by code of conduct required by brokers and state licensing agencies.</li>
                    <li>They know how to market your home and deal with buyers.</li>
                    <li>They know how to address issues that may come up during a transaction.</li>
                    <li>They understand state-required disclosures and look out for the seller's best interests.</li>
                    <li>They know how to negotiate the best deal for you.</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 mt-2">
                As a seller it is important to capture the dynamics of the current market conditions. Any property that
                is in the market for too long will lose interest among prospective buyers. It is imperative that your
                home is marketed and presented in the best possible to buyers and their agents to help you close the
                deal successfully in the shortest amount of time.
                <br /><br />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                When you choose to dispense with the services of an agent, you are giving up the best possible way to
                know and monitor local market conditions. You need to schedule showings and visits around your work and
                personal priorities which can be cumbersome as the listing period increases. By enlisting the services
                of a professional real estate agent, you can get a much more convenient home selling experience.
                <br /><br />
              </div>
            </div>
            <h4 class="my-3 headWrap">Copyright Notices & Disclaimers</h4>
            <div>
              <strong> {{ cmaViewDetails?.mls ? cmaViewDetails.mls : 'Public Records' }} </strong><br /><br />
              The real estate listing information and related content displayed is provided exclusively for consumers'
              personal, non-commercial use and may not be used for any purpose other than to identify prospective
              properties consumers may be interested in purchasing.
              <span *ngIf="cmaViewDetails?.mls">
                This information and related content is deemed reliable but is not guaranteed accurate by the
                {{ cmaViewDetails.mls }}. Copyright ©2025 {{ cmaViewDetails.mls }}. All rights reserved.
              </span>
              <span *ngIf="!cmaViewDetails?.mls">
                This information and related content is deemed reliable but is not guaranteed. Copyright ©2025, all
                rights reserved.
              </span>
            </div>
          </div>
          <div class="col-md-12" *ngIf="cmaViewDetails?.reportCategory == 'smartReport'">
            <h4 class="my-3 headWrap">Copyright Notices & Disclaimers</h4>
            <div>
              <strong> {{ cmaViewDetails?.mls ? cmaViewDetails.mls : 'Public Records' }} </strong><br /><br />
              The real estate listing information and related content displayed is provided exclusively for consumers'
              personal, non-commercial use and may not be used for any purpose other than to identify prospective
              properties consumers may be interested in purchasing.
              <span *ngIf="cmaViewDetails?.mls">
                This information and related content is deemed reliable but is not guaranteed accurate by the
                {{ cmaViewDetails.mls }}. Copyright ©2025 {{ cmaViewDetails.mls }}. All rights reserved.
              </span>
              <span *ngIf="!cmaViewDetails?.mls">
                This information and related content is deemed reliable but is not guaranteed. Copyright ©2025, all
                rights reserved.
              </span>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
